import moment from 'moment';
import CryptoJS from 'crypto-js';
import { CHILDREN_VALUE, PARTNER_VALUE, MAX_INSURED_AGE } from './constants';
import { decryptCredentials } from './cifrate';

const isEmpty = (object) => Object.keys(object).every((key) => !object[key]);

const getAge = (date) => {
  const formatDate = moment(date, 'DD/MM/YYYY');
  return moment().diff(formatDate, 'years');
};

const ageValidate = (birthdate, relationship, holderAge) => {
  const today = new Date();
  const { day, month, year } = birthdate;
  let dayVar = false;
  let monthVar = false;
  let yearVar = false;
  let isValidDay = true;

  if (day.length) {
    dayVar = Number(day) < 32 && Number(day) !== 0;

    if (month.length) {
      const validDay = new Date(Number(year), Number(month), 0).getDate();
      isValidDay = Number(day) <= validDay;
    }
  }

  if (month.length) {
    monthVar = Number(month) <= 12 && Number(month) !== 0;
  }

  if (year.length) {
    yearVar = (/^(19|20)\d{2}$/).test(year);
  }

  if (day.length && month.length && year.length && Number(today.getFullYear()) <= Number(year)) {
    if (!moment(`${year}-${month}-${day}`).isBefore(`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`)) {
      return {
        showError: true,
      };
    }
  }

  return {
    showError: (day.length && !dayVar)
      || (month.length && !monthVar)
      || (year.length && !yearVar)
      || !isValidDay
      || (relationship === CHILDREN_VALUE && (Number(holderAge) < Number(getAge(`${day}/${month}/${year}`))))
      || (relationship === CHILDREN_VALUE && (Number(getAge(`${day}/${month}/${year}`)) >= 18))
      || (relationship === PARTNER_VALUE && (Number(getAge(`${day}/${month}/${year}`)) < 18))
      // || relationship === PARTNER_VALUE && (Number(getAge(`${day}/${month}/${year}`)) >= 99)
      || (relationship === PARTNER_VALUE && (Number(getAge(`${day}/${month}/${year}`)) > 60)),
    day: (day.length && !dayVar) || !isValidDay,
    month: month.length && !monthVar,
    year: year.length && !yearVar,
  };
};

const getErrorText = (birthdate, relationship, holderAge) => {
  let text;
  const { day, month, year } = birthdate;
  const age = Number(getAge(`${day}/${month}/${year}`));

  if (year.length > 3 && day !== '' && month !== '') {
    if (relationship === CHILDREN_VALUE && (Number(holderAge) < age)) {
      text = '*El hijo o hija debe ser menor que el titular';
      return text;
    }
    if (relationship === CHILDREN_VALUE && year.length > 3 && age >= 18) {
      text = '*Tu hijo o hija debe ser menor de edad';
      return text;
    }
    if (relationship === PARTNER_VALUE && year.length > 3 && age < 18) {
      text = '*Tu cónyuge debe ser mayor de edad';
      return text;
    }
    if (relationship === 1 && year.length > 3 && age > MAX_INSURED_AGE) {
      text = `*El conyuge debe ser menor de ${MAX_INSURED_AGE} años`;
      return text;
    }
  }
  text = '*Tu fecha de nacimiento es inválida';
  return text;
};

const getBeginningValidity = () => moment().add(1, 'day').format('YYYY-MM-DD');
const getBeginningValidityFormat = () => moment().add(1, 'day').format('DD/MM/YYYY');

const getEndValidity = () => moment().add(1, 'years').format('YYYY-MM-DD');

export function encryptAES(
  plainText,
  password,
  config = { keySize: 256, iterations: 1 },
) {
  const { keySize } = config;
  const { iterations } = config;
  const salt = CryptoJS.lib.WordArray.random(128 / 8);

  const key = CryptoJS.PBKDF2(password, salt, {
    keySize: keySize / 32,
    hasher: CryptoJS.algo.SHA512,
    iterations,
  });

  const iv = CryptoJS.lib.WordArray.random(128 / 8);

  const encrypted = CryptoJS.AES.encrypt(plainText, key, {
    iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  return encrypted.toString() + iv.toString() + salt.toString();
}

export function decryptAES(encryptedMessage, password, config = { keySize: 256, iterations: 1 }) {
  const { keySize } = config;
  const { iterations } = config;

  const salt = CryptoJS.enc.Hex.parse(encryptedMessage.substr(encryptedMessage.length - 32));
  const iv = CryptoJS.enc.Hex.parse(encryptedMessage.substr(encryptedMessage.length - 64, 32));
  const encrypted = encryptedMessage.substr(0, encryptedMessage.length - 64);

  const key = CryptoJS.PBKDF2(password, salt, {
    keySize: keySize / 32,
    hasher: CryptoJS.algo.SHA512,
    iterations,
  });

  const decrypted = CryptoJS.AES.decrypt(encrypted, key, {
    iv,
    padding: CryptoJS.pad.Pkcs7,
    mode: CryptoJS.mode.CBC,
  });

  const decryptedMessage = decrypted.toString(CryptoJS.enc.Utf8);
  if (!decryptedMessage) {
    throw new Error('Decrypt Error');
  }

  return decryptedMessage;
}

const securityDecode = [JSON.parse(decryptCredentials(process.env.REACT_APP_SECURITYCODE))];

export const getCodeSecurity = () => securityDecode[0].password;

export const sendMessageToApp = (label) => {
  /* Envío de mensaje android */
  /* Envío de mensaje para ios */
  if (window.webkit) {
    window.webkit.messageHandlers.MessageHandler.postMessage(label);
  }
};

export {
  isEmpty,
  getAge,
  ageValidate,
  getErrorText,
  getEndValidity,
  getBeginningValidity,
  getBeginningValidityFormat,
};
